import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../App';
import { readGoogleReturn, clearGoogleReturn, googleRedirectUri } from '../lib/googleAuth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const ret = readGoogleReturn();
    if (!ret) {
      toast.error('Google sign-in failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }
    if (ret.flow === 'challenge') {
      window.location.replace('/challenge/auth/google' + window.location.search);
      return;
    }
    axios.post(`${API_URL}/api/auth/google/session`, { code: ret.code, redirect_uri: googleRedirectUri() }, { withCredentials: true })
      .then(({ data }) => {
        clearGoogleReturn();
        setUser(data);
        toast.success(`Welcome, ${data.name || 'back'}!`);
        const isAdmin = data.role === 'admin' || data.role === 'super_admin';
        navigate(isAdmin ? '/admin' : (ret.next || '/'), { replace: true, state: { user: data } });
      })
      .catch((e) => {
        clearGoogleReturn();
        toast.error(e.response?.data?.detail || 'Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center" data-testid="google-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#1D4ED8] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#475569]">Signing you in with Google...</p>
      </div>
    </div>
  );
}
